export interface SalesOrderLinePicking {
  id: string;
  orderType: string;
  salesOrderHeaderId: string;
  salesOrderStockAllocationId: string;
  salesOrderAndLineNo: string;
  purchaseOrderHeaderId: string;
  purchaseOrderStockAllocationId: string;
  purchaseOrderAndLineNo: string;
  customerAccount: string;
  customerName: string;
  orderNo: number;
  sequence: number;
  customerOrderRef: string;
  status: string;
  allocationType: string;
  productType: string;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  quantity: number;
  unitOfMeasure: string;
  noOfItems: number;
  deliveryDate: Date;
  proformaOrder: string;
  proformaPaid: string;
  creditCheckPassed: string;
  depositOrder: string;
  depositPaid: string;
  deliveryAddress: string;
  countryName: string;
  enteredBy: string;
  euCountry: string;
  reserved: string;
  holdStock: boolean;
  allocations: boolean;
}
